<template>
  <div class="go-home">
    <div class="go-home-nei" @click="show = !show && !$from">
      <img class="log-img-icon" src="/static/ball.png" />
    </div>
    <template v-if="show && !$from">
      <div class="home-bar home-bar-top" @click="changeView('/home')"><i class="icon DYT_icon_font icon-shouye"></i></div>
      <div class="home-bar home-bar-top-right" @click="go('/hospital')"><i class="icon DYT_icon_font icon-yiyuanguahao"></i></div>
      <div class="home-bar home-bar-right" @click="go('/center')"><i class="icon DYT_icon_font icon-gerenzhongxin"></i></div>
    </template>
  </div>
</template>

<script>
export default {
  methods: {
    changeView: function (path) {
      this.$router.push(path)
      this.show = false
    },
    go(url) {
      if (!localStorage.getItem('authtoken') && window.__wxjs_environment === 'miniprogram') {
        window.wx.miniProgram.redirectTo({
          url: `/pages/login/index`
        })
        return
      }
      location.href = `https://${this.$isTest ? 'test.ynhdkc.com' : 'app.ynhdkc.com'}${url}&jwt=${this.$token}&isNewToken=1`
    }
  },
  data: function () {
    return {
      show: false
    }
  }
}
</script>

<style scoped lang="less">
@import '../styles/base.less';

.go-home {
  position: fixed;
  bottom: 2.6em;
  right: 2.6em;
  .go-home-nei {
    background-color: @main_color;
    width: 3.4em;
    height: 3.4em;
    border-radius: 50%;
    z-index: 10;
    display: flex;
    justify-content: center;
    align-items: center;
    box-shadow: 0 0 1em 0.5em rgba(220, 220, 220, 0.7);
    .log-img-icon {
      width: 2em;
      height: 2em;
    }
  }
}
.home-bar {
  position: absolute;
  background-color: @main_color;
  width: 2.8em;
  height: 2.8em;
  border-radius: 50%;
  color: #fff;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 0 0 1em 0.2em rgba(220, 220, 220, 0.7);
  font-size: 1.1em;
  &.home-bar-top {
    top: -4.6em;
    right: 0em;
  }
  &.home-bar-right {
    top: 1em;
    right: 5em;
  }
  &.home-bar-top-right {
    top: -2.5em;
    right: 3.5em;
  }
}
</style>
